import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente en tu mail tras la compra. Tendrás acceso de por vida a todos los archivos digitales para leerlos en tu celular, tablet o computadora.'
  }, {
    q: '¿Es apto para todo público?',
    a: 'Sí, el lenguaje es claro, simple y directo al grano. No usamos terminología médica compleja, está diseñado para que cualquier persona pueda aplicarlo.'
  }, {
    q: '¿Necesito conocimientos previos?',
    a: 'No, te llevamos de la mano desde cero. El programa está estructurado paso a paso para que aprendas a descodificar tu cuerpo sin experiencia previa.'
  }];
  return <section className="py-24 bg-holistic-cream" data-id="element-37">
      <div className="max-w-3xl mx-auto px-6" data-id="element-38">
        <FadeIn data-id="element-39">
          <div className="text-center mb-12 flex flex-col items-center" data-id="element-40">
            <HelpCircle size={40} className="text-holistic-sage mb-4" data-id="element-41" />
            <h2 className="text-3xl font-serif text-holistic-earth" data-id="element-42">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-6" data-id="element-43">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-44">
              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-holistic-sand" data-id="element-45">
                <h3 className="text-xl font-bold text-holistic-earth mb-3" data-id="element-46">
                  {faq.q}
                </h3>
                <p className="text-holistic-earth-light leading-relaxed" data-id="element-47">
                  {faq.a}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}